import { render, staticRenderFns } from "./advice.vue?vue&type=template&id=0363694e&"
import script from "./advice.vue?vue&type=script&lang=js&"
export * from "./advice.vue?vue&type=script&lang=js&"
import style0 from "./advice.vue?vue&type=style&index=0&id=0363694e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports